// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20ylK","select":"styles_select__Jah_U"};